import React from "react";
import {
  CASE_STUDIES_BADGE,
  CASE_STUDIES_TITLE,
  CASE_STUDIES_DESCRIPTION,
} from "./CreatorCaseStudies.constants";
import { CaseStudyCard } from "./CaseStudyCard";
import { useCreatorCaseStudies } from "./useCreatorCaseStudies";
import { CREATOR_CASE_STUDIES_PROPS } from "./CreatorCaseStudies.types";

export const CreatorCaseStudies = ({
  cards: customCards,
  containerClassName,
}) => {
  const { cards, handleCardClick } = useCreatorCaseStudies(customCards);

  return (
    <section className={`tw-py-16 ${containerClassName}`}>
      <div className="tw-max-w-6xl tw-mx-auto">
        {/* Header */}
        <div className="tw-mb-8">
          <div className="tw-text-xs tw-font-bold tw-tracking-wider tw-text-[#4E39DF] tw-uppercase tw-mb-2">
            {CASE_STUDIES_BADGE}
          </div>
          <h2 className="tw-text-xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-m-0 tw-mb-0">
            {CASE_STUDIES_TITLE}
          </h2>
          <p className="tw-text-sm tw-text-slate-500 tw-m-0 tw-leading-relaxed">
            {CASE_STUDIES_DESCRIPTION}
          </p>
        </div>

        {/* Dynamic Reusable Cards Grid */}
        <div className="tw-grid tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-5">
          {cards.map((card) => (
            <CaseStudyCard
              key={card.id}
              card={card}
              onCardClick={handleCardClick}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

CreatorCaseStudies.propTypes = CREATOR_CASE_STUDIES_PROPS;

CreatorCaseStudies.defaultProps = {
  cards: null,
  containerClassName: "",
};
